import { render, staticRenderFns } from "./reviewReply.vue?vue&type=template&id=3c60829a&lang=pug"
import script from "./reviewReply.vue?vue&type=script&lang=js"
export * from "./reviewReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports